import { render, staticRenderFns } from "./diet.vue?vue&type=template&id=0a0626b4&"
import script from "./diet.vue?vue&type=script&lang=js&"
export * from "./diet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports